module.exports = function() {
  return function(value) {
    const regex = /^[a-z]{2}(-[A-Z]{2})?$/
    return regex.test(value)
  }
}
